import { Reducer, Action } from "redux";
import {
    IForgotPasswordState,
    KnownAction,
    SUBMIT_EMAIL,
    SUBMIT_COMMUNICATION_METHOD,
    SELECT_COMMUNICATION_METHOD,
    ADD_USER_ID,
    SECURITY_QUE_NOT_AVAILABLE,
} from "./types";

export const reducer: Reducer<IForgotPasswordState> = (state: IForgotPasswordState | undefined, incomingAction: Action): IForgotPasswordState => {
    if (state === undefined) {
        return { email: "", communicationMethodList: [], selectedMethod: "", userId: "" };
    }

    const action = incomingAction as KnownAction;
    switch (action.type) {
        case SUBMIT_EMAIL:
            return {
                ...state,
                email: action.email,
            };
        case ADD_USER_ID:
            return {
                ...state,
                userId: action.userId,
            };
        case SUBMIT_COMMUNICATION_METHOD:
            return {
                ...state,
                communicationMethodList: action.communicationMethodList,
            };
        case SELECT_COMMUNICATION_METHOD:
            return {
                ...state,
                selectedMethod: action.selectedMethod,
            };
        case SECURITY_QUE_NOT_AVAILABLE:
            return {
                ...state,
                isSecurityQueNotAvailable: action.isSecurityQueNotAvailable,
            };
        default:
            return state;
    }
};
